/*=========================================================================================
  File Name: module-internall-getters.js
  Description: Internal Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA Internal
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {};
